/** Aufgeklappte Lot-Zeile eines Artikels: Provenienz je Lieferung inkl. MHD und Aktionen. */
import { useI18n } from "@/i18n";
import { Th, Td } from "@/components/common";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/inventory/ExpiryTab";

export default function InventoryLotRows({ row, group, locEnabled, canEdit, canEditBbd,
  qLabelOf, onTransfer, onBbd, onWriteOff }) {
  const { t, fmtDate } = useI18n();
  const lotActions = (l, i) => (
    <Td right><div className="flex justify-end gap-1">
      {locEnabled && (
        <Button size="sm" variant="outline" className="h-7" data-testid={`lot-transfer-${row.sku}-${i}`}
          onClick={() => onTransfer({ variant: row, lots: [l] })}>{t("tr.transfer")}</Button>)}
      {canEditBbd && (
        <Button size="sm" variant="outline" className="h-7" data-testid={`lot-bbd-${row.sku}-${i}`}
          onClick={() => onBbd({ ...l, sku: row.sku, product_name: row.product_name })}>
          {l.best_before_date ? t("bbd.correct") : t("bbd.assign")}</Button>)}
      <Button size="sm" variant="outline" className="h-7" data-testid={`lot-write-off-${row.sku}-${i}`}
        onClick={() => onWriteOff({ ...l, sku: row.sku, product_name: row.product_name })}>{t("wo.action")}</Button>
    </div></Td>
  );

  return (
    <tr className="bg-muted/20">
      <td colSpan={10} className="px-4 py-3">
        <div className="mb-2 text-xs font-medium text-muted-foreground">
          {t("ex.deliveries")} · {t("ex.totalStock")}: <span className="font-mono text-foreground">{group.total}</span>
        </div>
        <div className="overflow-x-auto rounded-md border border-border bg-card">
          <table className="w-full min-w-[720px] text-xs" data-testid={`lots-table-${row.sku}`}>
            <thead className="bg-muted/50"><tr>
              <Th>{t("ex.delivery")}</Th><Th>{t("ex.supplierLot")}</Th>
              <Th>{t("ex.receipt")}</Th><Th>{t("ex.receivedAt")}</Th><Th>{t("ex.bbd")}</Th>
              <Th right>{t("ex.daysLeft")}</Th><Th>{t("ex.filterStatus")}</Th>
              <Th right>{t("common.quantity")}</Th><Th>{t("ex.quality")}</Th><Th>{t("ex.warehouse")}</Th>
              {locEnabled && <Th>{t("ex.location")}</Th>}
              {canEdit && <Th right></Th>}
            </tr></thead>
            <tbody>
              {group.lots.map((l, i) => (
                <tr key={`${l.lot_id || l.purchase_receipt_id || "lot"}-${i}`} data-testid={`lot-row-${row.sku}-${i}`}>
                  <Td mono>{i + 1}{l.fefo_rank === 1 && l.best_before_date
                    ? <span className="ml-1 rounded bg-primary/10 px-1 text-primary" title={t("ex.fefoNext")}>FEFO</span>
                    : null}</Td>
                  <Td mono>{l.lot_number || "—"}</Td>
                  <Td>{l.receipt_reference || "—"}
                    {l.receipt_type === "initial_stock" && (
                      <span className="ml-1 rounded bg-muted px-1 text-[10px] text-muted-foreground"
                        data-testid={`lot-initial-${row.sku}-${i}`}>{t("tr.initialStockLabel")}</span>)}</Td>
                  <Td>{l.received_at ? fmtDate(l.received_at) : "—"}</Td>
                  <Td>{l.best_before_date ? fmtDate(l.best_before_date) : "—"}</Td>
                  <Td right mono>{l.days_left == null ? "—" : l.days_left}</Td>
                  <Td><StatusBadge status={l.status} /></Td>
                  <Td right mono className="font-semibold">{l.quantity}</Td>
                  <Td>{qLabelOf(l.quality)}</Td>
                  <Td>{l.warehouse_name || "—"}</Td>
                  {locEnabled && <Td mono>{l.location_code || "—"}</Td>}
                  {canEdit && lotActions(l, i)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </td>
    </tr>
  );
}
